import React, { useState } from 'react'
import Table from '../../common/Table';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getContestWiseEarning } from '../../redux/services/contestEarningSlice';
import moment from 'moment-timezone';
import { convertIstToUtc } from '../../common/TimeUtils';

const ContestwiseEarning = () => {
    const dispatch = useDispatch();
    const [toggle, setToggle] = useState(false);
    const [savedStartDate, setSavedStartDate] = useState(null);
    const [savedEndDate, setSavedEndDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const getContestWiseEarningData = useSelector(state => state.contestEarning.contestWiseData);
    const handleDateSubmit = () => {
        let adjustedStartDate = null;
        if (startDate) {
          adjustedStartDate = new Date(startDate);
          adjustedStartDate.setHours(0, 0, 0, 0);
        }
    
        let adjustedEndDate = null;
        if (endDate) {
          adjustedEndDate = new Date(endDate);
          adjustedEndDate.setHours(23, 59, 59, 999);
        }
        const SDate = adjustedStartDate ? convertIstToUtc(adjustedStartDate) : null;
        const EDate = adjustedEndDate ? convertIstToUtc(adjustedEndDate) : null;
        if (SDate && EDate) {
          setToggle(false);
          getAllContestWiseEarning(SDate, EDate);
          setStartDate(convertIstToUtc(moment().subtract(24, "hours").toISOString()));
          setEndDate(convertIstToUtc(moment().toISOString()));
        } else {
        }
        return { SDate, EDate };
      };
      const handleSaveDate = () => {
        setSavedStartDate(startDate);
        setSavedEndDate(endDate);
        if (handleDateSubmit) {
          handleDateSubmit();
        }
      };
    const getAllContestWiseEarning = useCallback(async (startDate, endDate) => {
        const SDate =startDate ? startDate: convertIstToUtc(moment().subtract(24, "hours").toISOString())
        const EDate = endDate ? endDate: convertIstToUtc(moment().toISOString());
        const payload = { startDate: SDate, endDate: EDate };
        try {
         const response = await dispatch(getContestWiseEarning(payload));
          if(response.payload.status === 200){
            setStartDate("");
            setEndDate("");
          }
        } catch (error) {}
      }, [dispatch,]);
    
      useEffect(() => {
        getAllContestWiseEarning();
      }, [getAllContestWiseEarning]);
      const columns = [
        {
          header: "S/N",
          key: "index",
          render: (_, __, index) => index + 1,
        },
        { header: "Contest Name", key: "contestName" },
        { header: "Count", key: "count" },
        { header: "Earning ", key: "earning" },
        { header: "Total Earning ", key: "totalEarnings" },
      ];
      const handleClearDates = () => {
        setStartDate("");
        setEndDate("");
        setSavedStartDate("");
        setSavedEndDate("");
        if (handleDateSubmit) {
          handleDateSubmit();
        }
      };
  return (
    <div>
       <Table
         title="Contest Wise Earning"
        columns={columns}
        data={getContestWiseEarningData}
        dateFilter={true}
        toggle={toggle}
        setToggle={setToggle}
        savedStartDate={savedStartDate}
        savedEndDate={savedEndDate}
        handleClearDates={handleClearDates}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        handleSaveDate={handleSaveDate}
        startDate={startDate}
        endDate={endDate}
       />
    </div>
  )
}

export default ContestwiseEarning;
